import {DOM} from "../DOM";

// Clean url to be shorter
export const SentryUtilCleanURI = (uri: string) : string => {
    const regex = /do=([a-zA-Z\-]+)/gm;
    let m = regex.exec(uri);
    if (!m || !m[1]) { return uri.replace(window.location.href, ''); }
    return m[1];
}

// Get ENV variable from body
export const SentryUtilGetEnvironment = () : number => {
    return parseInt(DOM.Parser.getDataByNameFromElement('env', DOM.Parser.getBodyElement()));
}

// Get session client is possible from body element
export const SentryUtilGetClient = () : { email: string; name: string; id: number }|undefined => {

    const client = DOM.Parser.getDataByNameFromElementOrNull('client', DOM.Parser.getBodyElement());
    if (!client) { return undefined; }
    const sessionClient = client ? JSON.parse(client) : null;

    const clientName =
        sessionClient.firstName && sessionClient.lastName
            ? `${sessionClient.firstName} ${sessionClient.lastName}`
            : (sessionClient.company ? sessionClient.company : sessionClient.id);

    const clientEmail =
        sessionClient.emailList && sessionClient.emailList[0]
            ? sessionClient.emailList[0]
            : undefined;

    return  { name : clientName, email: clientEmail, id: sessionClient.id }
}